(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', './Version'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Version'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.WidgetTemplateMetadata = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.Version);
  }
}(this, function(ApiClient, Version) {
  'use strict';

  /**
   * The WidgetTemplateMetadata model module.
   * @module model/WidgetTemplateMetadata
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>WidgetTemplateMetadata</code>.
   * @alias module:model/WidgetTemplateMetadata
   * @class
   * @param id
   * @param version
   */
  var exports = function(id, version) {

    this['id'] = id;


    this['version'] = version;
  };

  /**
   * Constructs a <code>WidgetTemplateMetadata</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WidgetTemplateMetadata} obj Optional instance to populate.
   * @return {module:model/WidgetTemplateMetadata} The populated <code>WidgetTemplateMetadata</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('langPrefer')) {
        obj['langPrefer'] = ApiClient.convertToType(data['langPrefer'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('version')) {
        obj['version'] = Version.constructFromObject(data['version']);
      }
    }
    return obj;
  }


  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;

  /**
   * @member {module:model/WidgetTemplateMetadata.LangPreferEnum} langPrefer
   */
  exports.prototype['langPrefer'] = undefined;

  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;

  /**
   * @member {module:model/Version} version
   */
  exports.prototype['version'] = undefined;


  /**
   * Allowed values for the <code>langPrefer</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LangPreferEnum = { 
    /**
     * value: AZERBAIJANI
     * @const
     */
    AZERBAIJANI: "AZERBAIJANI",
    
    /**
     * value: BENGALI
     * @const
     */
    BENGALI: "BENGALI",
    
    /**
     * value: BULGARIAN
     * @const
     */
    BULGARIAN: "BULGARIAN",
    
    /**
     * value: CATALAN
     * @const
     */
    CATALAN: "CATALAN",
    
    /**
     * value: CHINESE_SIMPLIFIED
     * @const
     */
    CHINESE_SIMPLIFIED: "CHINESE_SIMPLIFIED",
    
    /**
     * value: CHINESE_TRADITIONAL
     * @const
     */
    CHINESE_TRADITIONAL: "CHINESE_TRADITIONAL",
    
    /**
     * value: CROATIAN
     * @const
     */
    CROATIAN: "CROATIAN",
    
    /**
     * value: CZECH
     * @const
     */
    CZECH: "CZECH",
    
    /**
     * value: DANISH
     * @const
     */
    DANISH: "DANISH",
    
    /**
     * value: DUTCH
     * @const
     */
    DUTCH: "DUTCH",
    
    /**
     * value: EGYPTIAN_ARABIC
     * @const
     */
    EGYPTIAN_ARABIC: "EGYPTIAN_ARABIC",
    
    /**
     * value: ENGLISH_UK
     * @const
     */
    ENGLISH_UK: "ENGLISH_UK",
    
    /**
     * value: ENGLISH_US
     * @const
     */
    ENGLISH_US: "ENGLISH_US",
    
    /**
     * value: ESTONIAN
     * @const
     */
    ESTONIAN: "ESTONIAN",
    
    /**
     * value: FINNISH
     * @const
     */
    FINNISH: "FINNISH",
    
    /**
     * value: FRENCH
     * @const
     */
    FRENCH: "FRENCH",
    
    /**
     * value: GERMAN
     * @const
     */
    GERMAN: "GERMAN",
    
    /**
     * value: GREEK
     * @const
     */
    GREEK: "GREEK",
    
    /**
     * value: HAUSA
     * @const
     */
    HAUSA: "HAUSA",
    
    /**
     * value: HEBREW
     * @const
     */
    HEBREW: "HEBREW",
    
    /**
     * value: HINDI
     * @const
     */
    HINDI: "HINDI",
    
    /**
     * value: HUNGARIAN
     * @const
     */
    HUNGARIAN: "HUNGARIAN",
    
    /**
     * value: INDONESIAN
     * @const
     */
    INDONESIAN: "INDONESIAN",
    
    /**
     * value: ITALIAN
     * @const
     */
    ITALIAN: "ITALIAN",
    
    /**
     * value: JAPANESE
     * @const
     */
    JAPANESE: "JAPANESE",
    
    /**
     * value: JAVANESE
     * @const
     */
    JAVANESE: "JAVANESE",
    
    /**
     * value: KOREAN
     * @const
     */
    KOREAN: "KOREAN",
    
    /**
     * value: LATVIAN
     * @const
     */
    LATVIAN: "LATVIAN",
    
    /**
     * value: LITHUANIAN
     * @const
     */
    LITHUANIAN: "LITHUANIAN",
    
    /**
     * value: NORWEGIAN
     * @const
     */
    NORWEGIAN: "NORWEGIAN",
    
    /**
     * value: PERSIAN
     * @const
     */
    PERSIAN: "PERSIAN",
    
    /**
     * value: POLISH
     * @const
     */
    POLISH: "POLISH",
    
    /**
     * value: PORTUGUESE
     * @const
     */
    PORTUGUESE: "PORTUGUESE",
    
    /**
     * value: ROMANIAN
     * @const
     */
    ROMANIAN: "ROMANIAN",
    
    /**
     * value: RUSSIAN
     * @const
     */
    RUSSIAN: "RUSSIAN",
    
    /**
     * value: SERBIAN
     * @const
     */
    SERBIAN: "SERBIAN",
    
    /**
     * value: SLOVAK
     * @const
     */
    SLOVAK: "SLOVAK",
    
    /**
     * value: SLOVENIAN
     * @const
     */
    SLOVENIAN: "SLOVENIAN",
    
    /**
     * value: SPANISH
     * @const
     */
    SPANISH: "SPANISH",
    
    /**
     * value: STANDARD_ARABIC
     * @const
     */
    STANDARD_ARABIC: "STANDARD_ARABIC",
    
    /**
     * value: SWAHILI
     * @const
     */
    SWAHILI: "SWAHILI",
    
    /**
     * value: SWEDISH
     * @const
     */
    SWEDISH: "SWEDISH",
    
    /**
     * value: THAI
     * @const
     */
    THAI: "THAI",
    
    /**
     * value: TURKISH
     * @const
     */
    TURKISH: "TURKISH",
    
    /**
     * value: UKRAINIAN
     * @const
     */
    UKRAINIAN: "UKRAINIAN",
    
    /**
     * value: VIETNAMESE
     * @const
     */
    VIETNAMESE: "VIETNAMESE",
    
    /**
     * value: ZULU
     * @const
     */
    ZULU: "ZULU"
  };

  return exports;
}));
